import { CustomFieldListItemProps } from "@/components/custom-field/list-item/custom-field-list-item.type.ts";
import { SalarySensitiveValue } from "@/components/sensitive-value/SalarySensitiveValue.tsx";
import useFormatter from "@/hooks/use-formatter.hook.ts";
import { ListItem } from "@skailer-com/uikit";

export function CustomFieldListItemCurrency({
  field,
  fieldValue,
  label,
}: CustomFieldListItemProps) {
  const { renderCurrency } = useFormatter();
  const value =
    fieldValue?.value_float == null
      ? null
      : renderCurrency(String(fieldValue.value_float), fieldValue?.value_text ?? null);

  return (
    <ListItem
      preTitle={label ?? field.title}
      titleSlot={<SalarySensitiveValue value={value} textClassName="text-title" />}
    />
  );
}
